export const getDemo = () => ({
  application: 'prekitt',
  pliURL: 'https://demo-pli.lwtears.com',
  agiURL: 'https://demo-agi.lwtears.com',
  apiGatewayURL: 'https://demo-api.lwtears.com',
  apiURL: `https://demo-api.lwtears.com/prekitt`,
  companyURL: 'https://demo-www.lwtears.com',
  gaTrackingId: 'UA-154381347-1',
  supportEmail: 'technology@lwtears.com',
  wmUrl: 'https://worksheet-maker.lwtears.com/0?lite=true',
  copyrightEmail: 'legal@lwtears.com',
  digitalProductSupportUrl: 'https://demo-www.lwtears.com/contact-us/digital-product-support'
});
